import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export default class DisputedFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <select
                className="filter-input"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={get(this.props, 'filter.value', '')}
            >
                <option value="">ALL</option>
                <option value={true}>DISPUTED</option>
                <option value="null">NOT DISPUTED</option>
            </select>
        );
    }
}
